import { render } from "./PlaceInfo.vue?vue&type=template&id=a72d8690&scoped=true"
import script from "./PlaceInfo.vue?vue&type=script&lang=js"
export * from "./PlaceInfo.vue?vue&type=script&lang=js"

import "./PlaceInfo.vue?vue&type=style&index=0&id=a72d8690&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72d8690"]])

export default __exports__